<template>
    <div class="point-center">
        <el-row class="description">
            <el-col>
                <div class="breadcrumb">
                    <div class="father">IoT Hub</div>
                    <div class="path">/</div>
                    <div class="now">Tag Management</div>
                </div>
                <div class="filter-wrap">
                    <el-input class="warningInput" v-model="queryInfo.search" placeholder="Please enter keywords to search"
                        suffix-icon="el-icon-search" clearable></el-input>

                    <span class="filter-label">Tag Type：</span>
                    <el-select class="stateSelect" v-model="queryInfo.p_type" placeholder="Please select" clearable
                        @clear="clearValue">
                        <el-option v-for="item in typelist" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>

                    <span class="filter-label">Tag Status：</span>
                    <el-select class="stateSelect" v-model="queryInfo.state" placeholder="Please select" clearable>
                        <el-option v-for="item in selectOption1" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="serchAllRuleData()" class="searchButton" round>Search</el-button>
                    <el-button @click="resetSearch()" class="resetButton" round>Reset</el-button>
                </div>
                <br />
                <div class="btn_box">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        <div class="check_box">
                            <el-checkbox v-model="checked" @change="clickcheck()">Select All</el-checkbox>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <div v-for="item in iconlist" class="iconbox" :style="'color:' + item.color" :key="item.id"
                                @click="openmylog(item.id)">
                                <el-upload class="upload-demo" :http-request="uploadFile" multiple
                                    :show-file-list="false" action="" :on-success="handleChange" v-if="item.id == 'd'">
                                    <div style="display: flex;align-items: center;">
                                        <img :src="item.img" alt="">
                                        {{ item.name }}
                                    </div>
                                </el-upload>
                                <div style="display: flex;align-items: center;" v-else>
                                    <img :src="item.img" alt="">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right_box">
                        <div class="add_box" @click="addrule()">
                            <img src="../../assets/Icons_User Interface_Plus cr-fr.png" alt="">
                            <div class="add_btn">
                                Add New
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="center table-common-wrap">
            <el-table ref="usertable" :data="warninglist" style="width: 100%">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
                <el-table-column prop="p_type" label="Tag Type" width="180" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.p_type.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Tag Name" width="180" align="center"></el-table-column>
                <el-table-column prop="eq_type" label="Associated Device" width="180" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.eq_type.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="p_code" label="Tag Code" width="180" align="center"></el-table-column>
                <el-table-column prop="cvalue" label="Current Value" width="180" align="center">
                </el-table-column>
                <el-table-column prop="noti_type" label="Command Setpoint" width="180" align="center">
                    <template slot-scope="scope">
                        <span v-if="!Array.isArray(scope.row.set_value)">{{ scope.row.set_value }}</span>
                        <span v-else>-</span>

                    </template>
                </el-table-column>
                <el-table-column prop="noti_type" label="Set Value（Upper Limit）" min-width="220" align="center">
                    <template slot-scope="scope">
                        <span v-if="Array.isArray(scope.row.set_value)">{{ scope.row.set_value[1]
                        }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="noti_type" label="Set Value（Lower Limit）" min-width="220" align="center">
                    <template slot-scope="scope">
                        <span v-if="Array.isArray(scope.row.set_value)">{{ scope.row.set_value[0]
                        }}</span>
                        <span v-else>-</span>

                    </template>
                </el-table-column>
                <el-table-column prop="noti_type" label="设备极限值（上限）" width="160" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ultimate[1] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="noti_type" label="设备极限值（下 限）" width="160" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ultimate[0] }}</span>

                    </template>
                </el-table-column>
                <el-table-column prop="step_amplitude" label="单步设定幅度" width="140" align="center">
                    <template slot-scope="scope">
                        [{{ scope.row.step_amplitude[0] }}, {{ scope.row.step_amplitude[1] }}]
                    </template>
                </el-table-column>
                <el-table-column prop="exe_interval" label="执行间隔（min）" width="140" align="center"></el-table-column>
                <el-table-column prop="created_at" label="单位" width="100" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.unit.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建人" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.creator.nickname }}
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="180" align="center"></el-table-column>
                <el-table-column prop="status" label="当前状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state == '1'">已启用</span>
                        <span v-if="scope.row.state == '0'" class="lookoff">已停用</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <span class="lookDetail" @click="lookDetail(scope.row)" style="color: rgba(76, 194, 164, 1);">
                            <img src="../../assets/编辑.png" alt="">编辑
                        </span>
                        <span v-if="scope.row.state == '1'" class="lookDetail" @click="openlog(scope.row, 'edit')"
                            style="color:rgba(255, 141, 26, 1);"><img src="../../assets/停止.png" alt="">停用</span>
                        <span v-if="scope.row.state == '0'" class="lookDetail" @click="changetype(scope.row, 'edit')"
                            style="color:rgba(36, 102, 168, 1);"><img src="../../assets/停止 (1).png" alt="">启用</span>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page page-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40]" :page-size="100" layout="->,total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="logtitle" :visible.sync="logVisible" width="30%" :before-close="Closelog">
            <div v-if="logtitle == '停用提示'" class="stop_text">
                停用该点位后，关联的设备都会受影响，是否确认停用该点位？
            </div>
            <div v-else class="delete_text">
                点位删除后，关联的设备都会受影响，且该点位无法被恢复，是否仍要删除该点位？
            </div>
            <div class="prj_footer" slot="footer">
                <div class="prj_content">
                    <div class="about">
                        <!-- <span>查看关联的规则</span> -->
                    </div>
                    <div>
                        <el-button @click="logVisible = false">取消</el-button>
                        <el-button type="warning" round @click="handleCommand(mycommand)"
                            v-if="logtitle == '停用提示' && mycommand">确认停用</el-button>
                        <el-button type="danger" round @click="handleCommand(mycommand)"
                            v-if="logtitle == '删除提示' && mycommand">确认删除</el-button>
                        <el-button type="warning" round @click="changetype(myrow)"
                            v-if="logtitle == '停用提示' && myrow">确认停用</el-button>
                        <!-- <el-button type="danger" round @click="deleterule(myrow)"
                            v-if="logtitle == '删除提示' && myrow">确认删除</el-button> -->
                    </div>
                </div>
            </div>
        </el-dialog>
        <adddialog :title="dialogtitle" :addDialogVisible="addDialogVisible" :infoid="infoid" @closedrawer="closedrawer"
            v-if="addDialogVisible">
        </adddialog>
        <el-dialog :title="logtitle" :visible.sync="uplodVisible" width="90%" :before-close="onDialogClose">
            <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
                <template v-for="(item, index) in tabletitle">
                    <el-table-column :label="item" :prop="item" width="180" align="center" v-if="item === '测试结果'"
                        :key="index">
                        <template slot-scope="scope">
                            <i class="iconfont" :class="scope.row['测试结果'] ? 'icon-dui' : 'icon-cuohao'" />
                        </template>
                    </el-table-column>
                    <el-table-column :label="item" :prop="item" width="180" align="center" v-else :key="index">
                    </el-table-column>
                </template>
            </el-table>
            <div class="prj_footer" slot="footer">
                <div class="prj_content">
                    <div class="about">
                        <el-upload class="upload-demo" :http-request="uploadFile" multiple :show-file-list="false"
                            action="" :on-success="handleChange">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                    <div>
                        <el-button @click="onTestData">一键测试</el-button>
                        <el-button @click="downloadFile">下载</el-button>
                        <el-button @click="commitupload">确认</el-button>
                        <el-button @click="uplodVisible = false">取消</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import config from '@/utils/config';
import adddialog from "./component/pointdialog";

export default {
    components: {
        adddialog,
    },
    data() {
        return {
            tabletitle: null,
            uplodVisible: false,
            tableData: null,
            infoid: null,
            addDialogVisible: false,
            warninglist: null,
            form: {
                name: '',
                des: ''
            },
            dialogtitle: null,
            alertAllData: null,
            heardlist: [{
                title: '',
                width: '5%'
            },
            {
                title: '规则编号',
                width: '10%'
            }, {
                title: '规则名称',
                width: '20%'
            }, {
                title: '规则说明',
                width: '25%'
            }, {
                title: '当前状态',
                width: '20%'
            }, {
                title: '操作',
                width: '20%'
            },
            ],
            iconlist: [
                {
                    id: 'a',
                    img: require("../../assets/停止 (1).png"),
                    color: 'rgba(36, 102, 168, 1)',
                    name: 'Enable',
                }, {
                    id: 'b',
                    img: require("../../assets/停止.png"),
                    color: 'rgba(255, 141, 26, 1)',
                    name: 'Disable',
                }, {
                    id: 'c',
                    img: require("../../assets/删除.png"),
                    color: 'rgba(184, 75, 75, 1)',
                    name: 'Delete',
                }, {
                    id: 'd',
                    img: require("../../assets/导入.png"),
                    color: 'rgba(0, 173, 136, 1)',
                    name: 'Batch Import',
                }
            ],
            selectOption1: [
                // { id: "-1", name: "全部" },
                { id: "0", name: "未启用" },
                { id: "1", name: "已启用" },
            ],
            selectOption2: [],
            modulesOption: [],
            queryInfo: {
                p_type: null,
                search: null,
                state: null,
                page: 1,
                size: 10,
            },
            total: 0,
            states: "",
            modules: "",
            dialogVisible: false,
            changeDialogVisible: false,
            changedata: {},
            serchnum: 0,
            type: 0,
            logVisible: false,
            myrow: null,
            checked: null,
            mycommand: null,
            logtitle: null,
            levellist: null,
            typelist: null
        };
    },
    created() {
        this.getall();
        this.gettypelist()
    },
    methods: {
        clearValue() {
            this.queryInfo.p_type = null
        },
        // 获取点位类型
        async gettypelist() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/p_type/all", {
                params: {
                    page: 1,
                    size: 10,
                },
            });
            if (res.code == 200) {
                this.typelist = res.data.results;
                // this.total = res.data.total;
            }
        },
        gotopublic() {
            this.$router.push({
                path: "/warningpublic",
            });
        },
        //获取点位列表
        async getall() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/point/all", {
                params: this.queryInfo,
            });
            if (res.code == 200) {
                this.warninglist = res.data.results;
                this.total = res.data.total;
            }
        },
        statesChange() {
            this.queryInfo.states = this.states;
        },
        modulesChange() {
            this.queryInfo.modules = this.modules;
        },
        //重置查询数据
        resetSearch() {
            // p_type: null,
            //     search: null,
            //         page: 1,
            //             size: 10,
            this.queryInfo.page = 1;
            this.queryInfo.size = 10;
            this.queryInfo.search = null;
            this.queryInfo.p_type = null;
            this.queryInfo.state = null;
            this.serchnum = 0;
            this.getall();
        },
        //查看点位详情
        async lookDetail(row) {
            console.log(row);
            this.infoid = row.id;
            this.dialogtitle = '编辑点位';
            this.addDialogVisible = true;
        },
        //打开新增页面
        addrule() {
            this.dialogtitle = '新增点位';
            this.addDialogVisible = true;
        },
        filterHandler(value, row, column) {
            const property = column["property"];
            return row[property] === value;
        },
        //删除告警规则
        async deleterule(row) {
            let idlist = [];
            idlist.push(row.id);
            console.log(idlist);
            const { data: res } = await this.$http.delete(config.httpPrefix + "/alarm/level/delete", {
                data: {
                    ids: idlist,
                }
            }
            );
            if (res.code == 200) {

                this.Closelog();
                return this.$message.success("删除当前告警规则成功");
                // return this.$message.success("修改告警规则成功");
            } else {
                return this.$message.error(res.msg);
            }
        },
        openlog(row, type) {
            if (type == 'edit') {
                this.logtitle = '停用提示'
            } else {
                this.logtitle = '删除提示'
            }
            this.logVisible = true
            this.myrow = row
            this.mycommand = null
        },
        //修改告警状态
        async changetype(row) {
            let idlist = [];
            let op_type = 'state';
            console.log(row);
            idlist.push(row.id);
            if (row.state == 1) {
                console.log(row);
                const { data: res } = await this.$http.post(config.httpPrefix + "/point/batch/" + op_type, {
                    op_type: op_type,
                    ids: idlist,
                    flag: 0,
                });
                // const { data: res } = await this.$http.put("/point/{id}", {
                //     ids: idlist,
                //     status: 0,
                // });
                if (res.code == 200) {
                    this.logVisible = false
                    this.getall();
                    return this.$message.success("修改点位启停状态成功");

                } else {
                    return this.$message.error("修改点位启停状态失败");
                }
            } else {
                console.log("启用");
                const { data: res } = await this.$http.post(config.httpPrefix + "/point/batch/" + op_type, {
                    op_type: op_type,
                    ids: idlist,
                    flag: 1,
                });
                if (res.code == 200) {
                    this.logVisible = false

                    this.getall();
                    return this.$message.success("修改点位启停状态成功");
                } else {
                    return this.$message.error("修改点位启停状态失败");
                }
            }
            this.getall();

        },
        openmylog(command) {
            this.myrow = null
            if (command == 'd') {
            } else {
                const usertablechose = this.$refs.usertable.selection;
                if (usertablechose.length === 0) {
                    return this.$message.error("没有选中任何点位");
                }
                if (command == 'b') {
                    this.logVisible = true
                    this.mycommand = command
                    this.logtitle = '停用提示'
                } else if (command == 'c') {
                    this.logVisible = true
                    this.mycommand = command
                    this.logtitle = '删除提示'
                } else {
                    this.handleCommand(command)
                }
            }
        },
        //批量启用告警规则
        async handleCommand(command) {
            console.log(command);
            const usertablechose = this.$refs.usertable.selection;
            // if (usertablechose.length === 0) {
            //     return this.$message.error("没有选中任何点位");
            // }
            let switchelist = [];
            for (var a = 0; a < usertablechose.length; a++) {
                console.log(usertablechose[a]);
                switchelist[a] = usertablechose[a].id;
            }
            // console.log(switchelist);
            if (command == "a") {
                let op_type = 'state';
                const { data: res } = await this.$http.post(config.httpPrefix + "/point/batch/" + op_type, {
                    op_type: op_type,
                    ids: switchelist,
                    flag: 1,
                });
                if (res.code == 200) {
                    this.Closelog()
                    return this.$message.success("批量修改点位状态成功");
                } else {
                    return this.$message.error("批量修改告点位状态失败");
                }
            } else if (command == "b") {
                let op_type = 'state';
                const { data: res } = await this.$http.post(config.httpPrefix + "/point/batch/" + op_type, {
                    op_type: op_type,
                    ids: switchelist,
                    flag: 0,
                });
                if (res.code == 200) {
                    this.Closelog()
                    return this.$message.success("批量修改点位状态成功");
                } else {
                    return this.$message.error("批量修改点位状态失败");
                }
            } else {
                let op_type = 'delete';
                const { data: res } = await this.$http.post(config.httpPrefix + "/point/batch/" + op_type, {
                    op_type: op_type,
                    ids: switchelist,
                    flag: 1,
                });
                if (res.code == 200) {
                    this.Closelog()
                    return this.$message.success("批量删除点位成功");
                } else {
                    return this.$message.error("批量删除点位失败");
                }
            }
        },

        handleClose() {
            this.getall();
            this.dialogVisible = false
        },
        Closelog() {
            this.checked = false
            this.myrow = null;
            this.mycommand = null;
            this.getall();
            this.logVisible = false
        },
        //新增规则
        async commit() {
            if (this.type == 1) {
                const { data: res } = await this.$http.put(
                    config.httpPrefix + "/alarm/level/info/update?id=" + this.form.id,
                    this.form
                );
                if (res.code == 200) {
                    this.handleClose()
                    return this.$message.success("修改告警规则成功");
                } else {
                    return this.$message.error(res.msg);
                }
            } else {
                const { data: res } = await this.$http.post(
                    config.httpPrefix + "/alarm/level/create",
                    this.form
                );
                if (res.code == 200) {
                    this.handleClose()
                    return this.$message.success("添加告警规则成功");
                } else {
                    return this.$message.error(res.msg);
                }
            }
            // console.log(res);
        },
        serchAllRuleData() {
            this.getall();
        },
        handleSizeChange(val) {
            this.queryInfo.size = val
            this.queryInfo.page = 1
            this.getall();
        },
        handleCurrentChange(val) {
            this.queryInfo.page = val
            this.getall();
            // console.log(`当前页: ${val}`);
        },
        clickcheck() {
            console.log(this.checked);
            if (this.checked) {
                this.toggleSelection(this.warninglist)
            } else {
                this.toggleSelection()
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.usertable.toggleRowSelection(row);
                });
            } else {
                this.$refs.usertable.clearSelection();
            }
        },
        closedrawer() {
            this.addDialogVisible = false;
            this.getall();
        },
        //上传文件
        async uploadFile(item) {
            let FormDatas = new FormData()
            console.log(item.file, this.res_name);
            FormDatas.append('file', item.file);
            console.log(FormDatas.get('file'));
            this.uploadfile = FormDatas
            console.log(FormDatas);
            // return
            this.$http({
                method: 'post',
                url: config.httpPrefix + '/point/upload/parse',
                data: FormDatas
            }).then(res => {
                console.log(res.data);
                console.log(this.tableData);
                this.warningtable = res.data.data
                if (this.warningtable) {
                    this.warningtable.map(q => {
                        this.tableData.map(v => {
                            if (v['序号'] == q.number) {
                                v['备注'] = q.msg;
                                v['测试结果'] = q.point_status;
                            }
                        })
                    })
                    console.log(this.tableData);
                    console.log(this.tabletitle);
                    this.tabletitle.unshift('备注')
                } else {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.data.msg
                        })
                    }
                }
                this.uplodVisible = true
                for (let a = 0; a < this.needfile.length; a++) {
                    console.log(this.needfile[a]);
                    if (res.data.data.title.includes(this.needfile[a])) {
                        this.res_name = this.needfile[a]
                    }
                }
                this.filelist.push(
                    {
                        res_title: res.data.data.title,
                        res_key: res.data.data.key,
                        res_type: res.data.data.type,
                        res_name: this.res_name,
                    }
                )
            })
        },
        tableRowClassName({ row, rowIndex }) {
            console.log(row);
            console.log(this.warningtable);
            if (this.warningtable) {

                for (let b = 0; b < this.warningtable.length; b++) {
                    if (row['序号'] == this.warningtable[b].number && this.warningtable[b].excel_status === 0) {
                        return 'warning-row';
                    }
                }
            } else {

                return '';
            }
        },
        handleChange(response, file, fileList) {
            this.fileContent = file.raw
            const fileName = file.name
            const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
            if (this.fileContent) {
                if (fileType === 'xlsx' || fileType === 'xls') {
                    this.importfile(this.fileContent)
                } else {
                    this.$message({
                        type: 'warning',
                        message: '附件格式错误，请重新上传！'
                    })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '请上传附件！'
                })
            }
        },
        importfile(obj) {
            const reader = new FileReader()
            const _this = this
            reader.readAsArrayBuffer(obj)
            reader.onload = function () {
                const buffer = reader.result
                const bytes = new Uint8Array(buffer)
                const length = bytes.byteLength
                let binary = ''
                for (let i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i])
                }
                const XLSX = require('xlsx')
                const wb = XLSX.read(binary, {
                    type: 'binary'
                })
                const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
                this.data = [...outdata]
                const arr = []
                this.data.map(v => {
                    const obj = {}
                    _this.tabletitle = Object.keys(v)
                    Object.keys(v).map(p => {
                        obj[p] = v[p]
                    })
                    // obj.ip = v.IP
                    // obj.name = v.NAME
                    arr.push(obj)
                })
                _this.tableData = arr
                console.log(_this.tabletitle);
            }
        },
        commitupload() {
            this.$http({
                method: 'post',
                url: config.httpPrefix + '/point/upload/save',
                data: this.uploadfile
            }).then(res => {
                console.log(res);
                if (res.data.code == 200) {
                    this.uplodVisible = false
                    this.getall()
                    return this.$message.success("录入设备成功");
                } else {
                    return this.$message.error(res.data.msg);
                }
            })
        },
        onDialogClose() {
            this.uplodVisible = false;
        },
        onTestData() {
            const index = this.tabletitle.indexOf("测试结果");
            if (index === -1) {
                this.tabletitle.unshift("测试结果");
            }
        },
        downloadFile() {
            this.$http({
                method: "post",
                url: config.httpPrefix + "/point/download",
                data: this.uploadfile,
                responseType: 'blob'
            }).then(res => {
                let fileName = "点位表格";
                const _res = res.data;
                let blob = new Blob([_res], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                });
                let downloadElement = document.createElement("a");
                let href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = `${fileName}.xlsx`;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.point-center {
    height: 100%;

    .breadcrumb {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18.75px;
        color: rgba(77, 74, 74, 1);

        .path {
            font-size: 14px;
            margin-left: 6px;
            margin-right: 6px;
        }

        .now {
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0px;
            line-height: 18.75px;
            color: rgba(36, 102, 168, 1);
            text-align: left;
            vertical-align: top;

        }
    }

    .description {
        margin: 25px;
        margin-top: 0px;
        padding-top: 36px;

        .el-input {
            width: 25%;
        }

        .addButton {
            margin-left: 0 !important;
        }
    }

    h2 {
        margin-top: 0px;
        margin-bottom: 30px;
    }

    .center {
        margin: 25px;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .el-input {
        display: inline-block !important;
        width: 25%;
    }

    .check_box {
        margin-right: 30px;

        ::v-deep .el-checkbox.is-checked {
            .el-checkbox__label {
                color: rgba(36, 102, 168, 1);
            }
        }
    }

    .iconbox {
        margin-right: 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        img {
            height: 21px;
            margin-right: 6px;
        }
    }

    .filter-label {
        margin-left: 40px;
        font-size: 16px;
        color: #878787;
    }

    .warningInput {
        width: 20%;
    }

    .stateSelect {
        width: 8%;
    }

    .btn_box {
        margin-top: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .searchButton {
        background-color: rgba(36, 102, 168, 1);
        border-color: rgba(36, 102, 168, 1);
        margin-left: 50px !important;
    }

    .resetButton {
        margin-left: 30px !important;
    }

    ::v-deep .el-table th.is-leaf {
        height: 60px;
        font-size: 15px;
        background: rgba(36, 102, 168, 0.1);
        color: #878787;
        border: none;
    }

    ::v-deep .el-table,
    .el-table__expanded-cell {
        background-color: transparent
    }

    ::v-deep .el-table::before {
        height: 0;
    }

    ::v-deep .el-table {
        height: 840px;

        .el-table__body-wrapper {
            max-height: calc(100% - 60px);
            overflow-y: scroll;
        }
    }

    .right_box {
        display: flex;
        align-items: center;
    }

    .add_box {
        cursor: pointer;
        width: 175px;
        height: 48px;
        opacity: 1;
        border-radius: 100px;
        background: rgba(36, 102, 168, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);

        img {
            height: 24px;
            margin-right: 8px;
        }

        .add_btn {
            height: 24px;
            line-height: 24px;
        }
    }

    .el-pagination {
        margin-top: 40px;
        margin-left: 20px;
        margin-bottom: 20px;
    }

    .stop_text {
        color: rgba(255, 141, 26, 1);
    }

    .delete_text {
        color: rgba(184, 75, 75, 1);
    }

    .lookon {
        display: inline-block;
        color: rgba(36, 102, 168, 1);
        width: 88px;
        height: 36px;
        line-height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgba(36, 102, 168, 0.1);
    }

    .lookoff {
        display: inline-block;
        color: rgba(103, 103, 103, 1);
        width: 88px;
        line-height: 36px;
        height: 36px;
        opacity: 1;
        border-radius: 68px;
        background: rgba(230, 231, 236, 1);
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid rgba(219, 219, 219, 1);
    }

    ::v-deep .el-dialog {
        opacity: 1;
        border-radius: 10px;
        background: rgba(255, 255, 255, 1);
    }

    .prj_content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .about {
            color: rgba(36, 102, 168, 1);
        }
    }

    ::v-deep {
        .el-table td.el-table__cell div {
            display: flex;
            justify-content: center; //水平
            align-items: center; //垂直
        }

        .el-table,
        .iconfont {
            font-size: 18px;
        }

        .el-table .icon-dui {
            color: #00AD88;
        }

        .el-table .icon-cuohao {
            color: #E33C64;
        }
    }


    .lookDetail {
        cursor: pointer;
        margin-right: 30px;
        line-height: 26px;
        display: flex;
        justify-content: center; //水平
        align-items: center; //垂直

        img {
            height: 16px;
            margin-right: 6px;
        }
    }

    .dotClass {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
    }

    .page {
        padding-bottom: 10px;
        margin-right: 25px;
    }

    ::v-deep .el-pagination { 
        .el-pagination__rightwrapper {
            display: flex;
            align-items: center;
        }
    }

    ::v-deep .el-pager li {
        width: 40px;
        height: 40px;
        opacity: 1;
        margin-left: 16px;
        margin-right: 16px;
        line-height: 40px;
        border-radius: 50%;
        color: rgba(103, 103, 103, 1);
        background: #E6E7EC;
    }

    ::v-deep .el-pager li.active {
        color: rgba(255, 255, 255, 1);
        background-color: rgba(36, 102, 168, 1);
        cursor: default;
    }

    ::v-deep .el-pagination .btn-prev {
        width: 40px;
        height: 40px;
        opacity: 1;
        border-radius: 50%;
        background: rgba(244, 246, 251, 1);
        border: 1px solid rgba(230, 231, 236, 1);
    }

    ::v-deep.el-pagination .btn-next {
        width: 40px;
        height: 40px;
        opacity: 1;
        border-radius: 50%;
        background: rgba(244, 246, 251, 1);
        border: 1px solid rgba(230, 231, 236, 1);
    }

    ::v-deep .el-pagination__jump {
        display: flex !important;
        align-items: center;
        font-size: 16px !important;

        .el-input {
            display: flex;
            align-items: center;
            width: 100px;

        }
    }

    ::v-deep .el-pagination__total {
        font-size: 16px !important;
        vertical-align: middle !important;
    }

    ::v-deep .el-pagination__sizes {
        display: flex !important;
        align-items: center;
        font-size: 16px !important;
        line-height: 40px !important;
        font-size: 16px !important;
        vertical-align: middle !important;
    }

    ::v-deep .el-input__inner {
        border-radius: 20px;
    }

    ::v-deep .el-textarea {
        width: 97%;
    }

    ::v-deep.el-table .warning-row {
        background: rgba(230, 99, 90, 0.5) !important;
    }
}
</style>
